import { useParams } from 'react-router-dom';
import { Box, Container, Grid } from '@mui/material';
import { useEffect } from 'react';

import PageTitleWrapper from 'src/components/PageTitleWrapper';
import PageHeader from 'src/components/pageHeader';
import Loader from 'src/components/Loader';
import NoDataFound from 'src/components/NoDataFound';

import DocumentsSection from './DocumentsSection';
import { useGetCaseDetailsMutation } from 'src/reduxServer/services/Cases';
import { useTranslation } from 'react-i18next';
const CaseDocuments = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [getCaseDetails, { data, isLoading, isError }] =
    useGetCaseDetailsMutation();

  useEffect(() => {
    if (id) {
      getCaseDetails(id);
    }
  }, [id, getCaseDetails]);

  const caseDetails = data?.case;
  const documents = caseDetails?.documents || [];

  if (isLoading) return <Loader />;
  if (isError || documents.length === 0) return (
  <Box sx={{ mt: 30 }}>
  <NoDataFound />
  </Box>
  );

  return (
    <>
      <PageTitleWrapper>
        <PageHeader title={t("Documents List")} />
      </PageTitleWrapper>

      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Grid container spacing={3}>
          {documents.map((doc: any) => (
            <Grid item xs={12} sm={6} md={4} key={doc.id}>
              <DocumentsSection doc={doc} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
};

export default CaseDocuments;
